export default {
  buttons: {
    title1: 'Ritaglia',
    title2: 'Chiudi',
  },
};
